import * as Actions from "../constants/UserConstants";

const InitialState = {
	dietaryPreferences: [],
	activeOrdersData: {},
	isNewUser: false,
	destinationAfterOnboard: ""
};

export const User = (state = InitialState, action: any) => {
	switch (action.type) {
		case Actions.SET_USER_DATA:
			const { allergens, ...rest } = action.data;

			return {
				...state,
				dietaryPreferences: allergens || state.dietaryPreferences,
				...rest,
			};

		case Actions.CLEAR_USER_DATA:
			return {
				...InitialState,
			};

		default:
			return {
				...state,
			};
	}
};

export default User;
